import React from 'react'
import '../style/Supscription.css'

function Supscription() {
    return (
        <div id="Supscription">
            <div className="price-card">
                <span className="price-title">Free</span>
                <hr className="line"></hr>
                <ul className="price-features">
                    <li className="price-item">
                        <i className="fas fa-check price-item-icon"></i> <span className="price-item-text">track upto 2 items</span> 
                    </li>
                    <li className="price-item">
                        <i className="fas fa-check price-item-icon"></i> <span className="price-item-text">basic features</span> 
                    </li>
                </ul>
                <button className="price-btn"> your plan </button>
            </div>

            <div className="price-card">
                <span className="price-title price-title-special">Premium</span>
                <hr className="line"></hr>
                <ul className="price-features">
                    <li className="price-item price-item-special">
                        <i className="fas fa-check price-item-icon"></i> <span className="price-item-text">track unlimited items</span> 
                    </li>
                    <li className="price-item price-item-special">
                        <i className="fas fa-check price-item-icon"></i> <span className="price-item-text">high security</span> 
                    </li>
                    <li className="price-item price-item-special">
                        <i className="fas fa-check price-item-icon"></i> <span className="price-item-text">instant mailing</span> 
                    </li>
                </ul>
                <button className="price-btn price-btn-special"> Go premium </button>
            </div>
        </div>
    )
}

export default Supscription